const SET_TOKEN = "SET_TOKEN";
const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";

export const authentication = {
  state() {
    return {
      token: null,
      refreshToken: null,
    };
  },
  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },
    getToken(state) {
      return state.token;
    },
    getRefreshToken(state) {
      return state.refreshToken;
    },
  },
  mutations: {
    [SET_TOKEN](state, token) {
      state.token = token;
    },
    [SET_REFRESH_TOKEN](state, refreshToken) {
      state.refreshToken = refreshToken;
    },
  },
  actions: {
    setToken({ commit }, token) {
      commit(SET_TOKEN, token);
    },
    setRefreshToken({ commit }, token) {
      commit(SET_REFRESH_TOKEN, token);
    },
    destroyTokens({ commit }) {
      commit(SET_TOKEN, null);
      commit(SET_REFRESH_TOKEN, null);
    },
  },
};
